export default {
    datefrom: 'ログイン日時',
    dateto: 'ログイン日時',
    location: '事業所',
    user: 'ユーザ'
};
